import { render, staticRenderFns } from "./LinkedFamilyCard.vue?vue&type=template&id=3433dbee&"
import script from "./LinkedFamilyCard.vue?vue&type=script&lang=js&"
export * from "./LinkedFamilyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports